<ng-container *ngIf="loadingSelectOptions; then loading else display"></ng-container>

<ng-template #loading>
  <p><i>Loading Reader Information...</i></p>
</ng-template>

<ng-template #display>
    <select class="form-control" [(ngModel)]="selectedOption" [ngModelOptions]="{standalone: true}">
        <option [ngValue]="null" selected="selected">-- Choose -- </option>
        <option *ngFor="let option of selectOptions" [ngValue]="option">
          {{option.mDisplay}}
        </option>
    </select>
</ng-template>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>